import useSWR from 'swr'
export const useSWRChainCodeState = () => {
  const { data: chainCode, mutate: setChain } = useSWR('chainCode', null, {})
  return { data: chainCode as string, setChain }
}
